<template>
	<el-container id="detalle">
		<el-row type="flex" justify="center">
			<el-col :xs="24" :sm="23" :md="22" :lg="21" :xl="18">
				<el-page-header
					:class="responsive.isMobile ? 'pageMobile' : ''"
					@back="goBack"
					:content="loadingproducto ? '' : this.producto.nombre"
				/>
				<el-row
					v-if="this.producto"
					:gutter="20"
					v-loading="loadingproducto"
					element-loading-text="Cargando el producto..."
					style="background-color: #fff; margin-top: 20px; min-height: 500px;"
				>
					<el-col v-if="!loadingproducto" :span="responsive.isMobile ? 24 : 14" style="padding: 30px;">
						<el-carousel
							:class="responsive.isMobile ? 'carouselMobile' : 'carousel'"
							indicator-position="outside"
							:arrow="responsive.isMobile ? 'always' : 'never'"
						>
							<el-carousel-item v-for="item in this.producto.url" :key="item">
								<el-image
									:src="'./api/public/proxy/files?&cooperativa=' + cooperativa + '&type=pedidos&archivo=' + item"
									fit="contain"
								/>
							</el-carousel-item>
						</el-carousel>
					</el-col>
					<el-col v-if="!loadingproducto" :span="responsive.isMobile ? 24 : 10" style="padding: 30px;">
						<el-row>
							<el-card shadow="never" :class="responsive.isMobile ? 'cardMobile' : 'card'">
								<div class="detalles">
									<h1>
										{{ this.producto.nombre }}
									</h1>
									<b>
										{{ this.producto.precio_final_con_formato }} por
										{{ this.producto.unimed_venta_completa }}
										<el-badge v-if="producto.es_nuevo" value="Nuevo" />
										<el-badge v-if="producto.es_promocion" value="Promo" />
									</b>
									<p class="bonif">
										{{ this.producto.bonificacion_uno !== '0.00' ? this.producto.bonificacion_uno_con_formato : '' }}
										{{ this.producto.bonificacion_uno !== '0.00' && this.producto.bonificacion_dos !== '0.00' ? ' + ' : '' }}
										{{ this.producto.bonificacion_uno !== '0.00' || producto.bonificacion_dos !== '0.00' ? ' OFF ' : '' }}
									</p>
									<!-- <p>{{ this.producto.descripcion }}</p> -->
									<p>{{ 'Producto: ' + producto.codart }}</p>
								</div>
								<!-- <div v-for="items in this.producto.unidad_medida_venta" :key="items.id"> -->
								<!-- <p  v-if="this.producto.cantidad_envase_con_formato">
									{{
										'Cantidad por ' +
										this.producto.unimed_venta_completa +
										': ' +
										this.producto.cantidad_envase_con_formato +
										' ' +
										this.producto.unimed_venta_completa
									}}
								</p> -->
								<el-row style="margin-top: 40px;">
									<el-col :span="!responsive.isMobile ? 12 : 24" style="text-align: center;">
										<cantidad
											:name="producto.unimed_venta_completa"
											:valor="this.cantidad"
											:method="setCantidad"
											style="margin-bottom: 30px;"
										/>
									</el-col>
									<el-col
										:span="!responsive.isMobile ? 12 : 24"
										:style="!responsive.isMobile ? 'text-align: center;' : 'text-align: center; width:-webkit-fill-available'"
									>
										<el-button
											:style="!responsive.isMobile ? '' : 'width:-webkit-fill-available'"
											@click="addProducto"
											type="primary"
											icon="el-icon-shopping-cart-1"
											:loading="this.loading"
											>{{ this.loading ? 'Agregando al carrito...' : 'Agregar al carrito' }}</el-button
										>
									</el-col>
								</el-row>
							</el-card>
						</el-row>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
		<!-- <carrito :visible="visibleCarrito" /> -->
	</el-container>
</template>
<script>
import Cantidad from '@/components/Cantidad.vue';
export default {
	components: { Cantidad },
	name: 'producto',
	inject: ['responsive'],
	props: {
		visiblec: {
			type: Boolean,
		},
		producto2: {
			type: Object,
		},
	},
	data() {
		return {
			visibleCarrito: false,
			temporal: 0,
			cantidad: 1,
			loading: false,
		};
	},
	computed: {
		producto() {
			return this.$store.state.pedidos.productodetallado;
		},
		carrito() {
			return this.$store.state.pedidos.carrito;
		},
		idcarrito() {
			return this.$store.state.pedidos.idcarrito;
		},
		loadingproducto() {
			return this.$store.state.pedidos.loadingproducto;
		},
		activeHost() {
			return this.$store.state.perfil.activeHost;
		},
		cooperativa() {
			return this.$store.state.config.cuit;
		},
	},
	methods: {
		addProducto() {
			this.loading = true;
			this.producto['pedido_id'] = this.idcarrito;
			this.producto['pedido_cantidad'] = this.cantidad;
			this.$store.dispatch('addProducto', this.producto).then(result => {
				this.loading = false;
			});
		},
		setCantidad(value) {
			this.cantidad = value;
		},
		goBack() {
			this.$router.push('/1/pedidos/');
		},
	},
};
</script>
<style scope lang="scss">
#detalle {
	.pageMobile {
		.el-page-header__content {
			font-size: 12px;
		}
		padding: 0px 5px 0px 10px;
		font-size: 10px;
	}
	.carousel {
		height: 500px;
		.el-carousel__container {
			height: 450px;
		}
	}
	.carouselMobile img {
		height: 200px;
	}
	.el-carousel__item {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.cardMobile {
		font-size: 15px;
		div .detalles {
			text-align: left;
			margin-right: 15px;
			font-size: 15px;
			h1 {
				font-size: 20px;
				margin: 0 0 10px 0;
			}
			b {
				font-size: 15px;
			}
			.bonif {
				color: #00a650;
				font-size: 15px;
				font-weight: bold;
			}
		}
	}
	.card {
		div .detalles {
			text-align: left;
			margin-right: 25px;
			h1 {
				font-size: 30px;
				margin: 0 0 20px 0;
			}
			b {
				font-size: 25px;
			}
			.bonif {
				color: #00a650;
				font-size: 15px;
				font-weight: bold;
			}
		}
	}
}
</style>
